import React from 'react';

export const Label = ({ className, ...props }) => (
    <label className={`block mb-1 ${className}`} {...props} />
);